module.exports = __webpack_public_path__ + "img/mobile-home-banner-2.d181ffff.png";